import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import FallBackError from './FallBackError';
import { FuelPortalService } from '../../services';

const FuelErrorBoundary = (props) => {
  const logError = async (error: Error) => {
    console.error('Caught error by Error boundary', {error});
    if (location.hostname !== 'localhost') {
      await FuelPortalService.sendUILogsToCloudWatch(error);
    }
  };

  const handleResetError = () => {
    location.href = '/';
  };
  return (
    <ErrorBoundary onError={logError} onReset={handleResetError} FallbackComponent={FallBackError}>
      {props.children}
    </ErrorBoundary>
  );
};

export default FuelErrorBoundary;
